import { useState, useEffect, React } from "react";
import { Button, TextInput, Stack, Grid, Column, IconButton, ButtonSet, FlexGrid, FileUploader, Row, Content, SelectItem, Select, Accordion, AccordionItem, Form, Loading, InlineNotification } from '@carbon/react';
import AdmonUsuariosTable from '../AdmonUsuarios/AdmonUsuariosTable';
import Cookies from "universal-cookie";
import { Edit, TrashCan } from '@carbon/react/icons';
import ErroresTable from "./ErroresTable";



const AdmonUsuarios = () => {
  const cookies = new Cookies();

  if (!sessionStorage.getItem('rfc') || !cookies.get('rfc')) {
    window.location.href = "/#/";
  }

  const [loading, setLoading] = useState(false);
  const [perfiles, setPerfiles] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [msgRegistro, setMsgRegistro] = useState([]);
  const [msgCargaMasiva, setMsgCargaMasiva] = useState([]);

  //CAMPOS FORMULARIO
  const [idUserHidden, setIdUserHidden] = useState(0);
  const [perfilSeleccionado, setPerfilSeleccionado] = useState("0");
  const [nombre, setNombre] = useState('');
  const [rfc, setRfc] = useState('');
  const [curp, setCurp] = useState('');
  const [numEmpleado, setNumEmpleado] = useState('');
  const [correo, setCorreo] = useState('');
  const [password, setPassword] = useState('');
  const [requiredPassword, setRequiredPassword] = useState(true);

  const [isTxtNumEmplDisabled, setTxtNumEmplDisabled] = useState(false);
  const [isTxtCorreoDisabled, setTxtCorreoDisabled] = useState(false);
  const [isTxtPasswordDisabled, setTxtPasswordlDisabled] = useState(false);
  const [isbtnConsultarUserDisabled, setIsBtnConsultarUserDisabled] = useState(true);
  const [isbtnRegUserDisabled, setIsBtnRegUserDisabled] = useState(true);
  const [isbtnsCargaMasivaDisabled, setIsBtnsCargaMasivaDisabled] = useState(true);

  const [isAltaOrActualizaUsuario, setAltaOrActualizaUsuario] = useState(0);
  const [isConsultaUsuEmp, setIsConsultaUsuEmp] = useState(false);
  const [isAgregarUsuEmp, setIsAgregarUsuEmp] = useState(false);
  const [isModificarUsuEmp, setIsModificarUsuEmp] = useState(false);
  const [isEliminarUsuEmp, setIsEliminarUsuEmp] = useState(false);

  const [btnCargarEmpl, setBtnCargarEmpl] = useState(true);
  const [rutaArchivoAcargar, setRutaArchivoAcargar] = useState("");
  const [showTableErrores, setShowTableErrores] = useState(false);
  const [rowsErrores, setRowsErrores] = useState([]);

  let headers = new Headers(); headers.append('Content-Type', 'application/json');
  
  var AU = {
    ColorHrLine: ({ color }) => (<hr style={{ color: color, backgroundColor: color, height: 2 }} />),
    spanHeight:  ({ height }) => (<span style={{ display: 'flex',alignItems: 'center',justifyContent: 'center', height: height }} />),
    getHeaders: function () {
      let headers = new Headers();
      headers.append('Content-Type', 'application/json');
      return headers;
    },
    hideMsgRegistro: function() {
      setMsgRegistro({ "showMsg": 0 });
    },
    hideMsgCargaMasiva: function() {
      setMsgCargaMasiva({ "showMsg": 0 });
    },
    catPerfiles: function () {
      setLoading(true);
      try{
          fetch(process.env.REACT_APP_URL_SERVICE_PERFILES_GET, {
            method: "POST",
            headers: AU.getHeaders()
          }).then((res) => res.json()).then((data) => {
              var perfiles = data.SDTPerfil;
              var perfilesList = perfiles.map(function (data) {
                  var rObj = {};
                      rObj["id"] = data.PerfilPerfilId;
                      rObj["text"] = data.PerfilNombre;
                  return rObj;
              });
              setPerfiles(perfilesList);
          });
        } catch(err) {
          console.log("Error al cargar perfiles: ",err);
        } finally {
          setLoading(false); 
        }
    },
    getPlantilla: async() => {
     
      const respuesta = await fetch(process.env.REACT_APP_URL_SERVICE_USUARIOS_DESCARGAR_PLANTILLA, {
                          method: "POST",
                          headers: AU.getHeaders,
                        });
      const resp = await respuesta.json();
                    if(resp.Estatus == 0){
                      window.open(resp.LinkDescarga);
                      setMsgCargaMasiva({ "showMsg": 1, "kind":"success", "Mensaje": "Se generó la plantilla satisfactoriamente."});
                      setTimeout(AU.hideMsgCargaMasiva, 6000);
                    } else {
                      setMsgCargaMasiva({ "showMsg": 1, "kind":"error", "Mensaje": resp.Mensaje});
                      setTimeout(AU.hideMsgCargaMasiva, 6000);
                    }
    },
    /** 
    *  USO DEL SERVICIO GXObject
    *  PARA SUBIR ARCHIVOS Y
    *  OBTENER EL PATCH. 
    * */
   subirArchivo: async() => {
    var files = new FormData();
    let divContainer = document.getElementById("fileEmpleados");
    const tipoPermitido = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet","application/vnd.ms-excel"];

    const input = divContainer.querySelector('input[type="file"]');
    const selectedFile = input.files[0];
    const mensaje = "Solo se permiten archivos '.xlsx o .xls'.";
   
    if (!tipoPermitido.includes(selectedFile.type)) {
      setBtnCargarEmpl(true);
      setMsgCargaMasiva({ "showMsg": 1, "kind":"error", "Mensaje": mensaje});
      setTimeout(AU.hideMsgCargaMasiva, 6000);
    } else {
      setBtnCargarEmpl(false);
      files.append("File", selectedFile);
      await fetch(process.env.REACT_APP_URL_SERVICE_USUARIOS_SUBIR_PLANTILLA, {
          method: "POST",
          body: files
        }).then((res) => res.json()).then((data) => {
          setRutaArchivoAcargar(data.files[0].path);
          setRowsErrores([]);
      });
    }
  },
  cargaMasivaEmpl: async() =>{
    setLoading(true);
    const pcRequest = {};
    setShowTableErrores(false);
    var isError = false;
    
    pcRequest.RutaArchivo = rutaArchivoAcargar;
    
    try{
        const respuesta = await  fetch(process.env.REACT_APP_URL_SERVICE_USUARIOS_CARGA_USUARIOS, {
                                  method: "POST",
                                  headers: AU.getHeaders(),
                                  body: JSON.stringify(pcRequest)
                          });
        const resp = await respuesta.json();

        if(resp.Estatus == 0){
          setMsgCargaMasiva({ "showMsg": 1, "kind":"success", "Mensaje": resp.Mensaje})
          setLoading(false);
          setTimeout(AU.hideMsgCargaMasiva, 6000);

        } else {
          var responseData = resp.col_ResultadoProcesamiento;
          let erroresPlantilla = [];

          setMsgCargaMasiva({ "showMsg": 1, "kind":"error", "Mensaje": resp.Mensaje});
          setShowTableErrores(true);
          setTimeout(AU.hideMsgCargaMasiva, 6000);
         
          var datos = responseData.map(function (obj) {
            var rObj = {};
            
            rObj["id"] = obj.ResultadoId;
            rObj["datosLinea"] = obj.ResultadoDatosLinea;
            rObj["descripcion"] = obj.ResultadoMensajes;

            if(!obj.ResultadoIsOk){
              erroresPlantilla.push(rObj);
            }
            
            return rObj;
          });
          
          setRowsErrores(erroresPlantilla);
          setLoading(false);
        }
      
      } catch(err) {
        console.log("Error: ", err);
        setLoading(false);
      }  
  },
  buscarUsuarios: function(){
      setLoading(true);
      let buRequest = {
        PerfilId: (perfilSeleccionado != "")?Number(perfilSeleccionado):0,
        Nombre: nombre,
        RFC: rfc,
        CURP: curp,
        NUM_EMPLEADO: numEmpleado,
        Correo: correo,
      }
  
      fetch(process.env.REACT_APP_URL_SERVICE_USUARIOS_GET, {
          method: "POST",
          headers: AU.getHeaders(),
          body: JSON.stringify(buRequest)
      }).then((res) => res.json()).then((data) => {
          var cont = 0;
          let response = data.SDTUsuarios;
          AU.catUsuarios = response;
          var arrayUsuarios = response.map(function (obj) {
            var rObj = {};
            rObj["Id"] = ++cont; //obj.Id;
            rObj["PerfilDesc"] = obj.PerfilNombre;
            rObj["NumEmpleado"] = obj.NUM_EMPLEADO;
            rObj["Nombre"] = obj.NOMBRE;
            rObj["RFC"] = obj.RFC;
            rObj["CURP"] = obj.CURP;
            rObj["Correo"] = obj.Correo;
            rObj["acciones"] = <> 
                                  {(isModificarUsuEmp &&
                                    <IconButton kind="ghost" label="Editar" onClick={() => { AU.editarUsuario(obj.Id) }}> <Edit /> </IconButton> 
                                  )}
                                  {(isEliminarUsuEmp &&
                                    <IconButton kind="ghost" label="Eliminar" onClick={() => { AU.eliminarUsuario(obj.RFC) }}> <TrashCan /> </IconButton>
                                  )}  
                                  </>;
            return rObj;
          });
          setUsuarios(arrayUsuarios);
          setLoading(false);
      });
    },
    altaUsuario: function(){
      let req = {}
      let auRequest = {
        PerfilId : perfilSeleccionado,
        NOMBRE : nombre,
        RFC : rfc,
        CURP : curp,
        NUM_EMPLEADO : numEmpleado,
        Correo : correo,
        Password : password,
    };
    req.SDTUsuario = auRequest;

      fetch(process.env.REACT_APP_URL_SERVICE_USUARIOS_POST, {
        method: "POST",
        headers: AU.getHeaders(),
        body: JSON.stringify(req)
      }).then((res) => res.json()).then((data) => {
          setMsgRegistro({ "showMsg": 1, "kind":(data.estatus == 0)?"success":"error", "Mensaje": data.Mensajes});
          AU.buscarUsuarios();
        });
    },
    editarUsuario: function (idUsuario){
      setIsBtnRegUserDisabled(false);
      setAltaOrActualizaUsuario(1);
      setIdUserHidden(idUsuario);
      setRequiredPassword(false);
     
      const cell = AU.catUsuarios.find(({ Id }) => Id == idUsuario);
      setPerfil(cell.PerfilId);
      setPerfilSeleccionado(cell.PerfilId);
      setNombre(cell.NOMBRE);
      setRfc(cell.RFC);
      setCurp(cell.CURP);
      setNumEmpleado(cell.NUM_EMPLEADO);
      setCorreo(cell.Correo);
      
    },
    actualizarUsuario: function (){
      setAltaOrActualizaUsuario(1);
      const usuarioId = sessionStorage.getItem('usuarioId');
      
      let req = {};
      let auRequest = {
            Id : idUserHidden,
            PerfilId : perfilSeleccionado,
            NOMBRE : nombre,
            RFC : rfc,
            CURP : curp,
            NUM_EMPLEADO : numEmpleado, 
            Correo : correo,
            Password : password
          };

      req.UsuarioIdModifica = usuarioId;
      req.SDTModificaUsuario = auRequest;
      fetch(process.env.REACT_APP_URL_SERVICE_USUARIOS_PUT, {
        method: "POST",
        headers: AU.getHeaders(),
        body: JSON.stringify(req)
      }).then((res) => res.json()).then((data) => {
        setMsgRegistro({ "showMsg": 1, "kind":(data.Estatus == 0)?"success":"error", "Mensaje": data.Mensaje});
        AU.buscarUsuarios();
      });
     
    },
    eliminarUsuario: function (rfc){
      const usuarioId = sessionStorage.getItem('usuarioId');
      const perfilId = sessionStorage.getItem('perfilId');

      let euRequest = {
        UsuarioId: usuarioId,
        PerfilId: perfilId,
        RFCBorrar: rfc,
      }
  
      fetch(process.env.REACT_APP_URL_SERVICE_USUARIOS_DELETE, {
          method: "POST",
          headers: AU.getHeaders(),
          body: JSON.stringify(euRequest)
      }).then((res) => res.json()).then((data) => {
          setMsgRegistro({ "showMsg": 1, "kind":(data.Estatus == 0)?"success":"error", "Mensaje": data.Mensaje});
          AU.buscarUsuarios();
      });

    },
    catUsuarios:null,
    validaPermisos: () => {
      let permisoUsuariosEmpl = cookies.get("modUsuarioEmpleados");
      let permisoCargaMasiva = cookies.get("modCargaMasiva");

      if(permisoUsuariosEmpl != undefined && permisoUsuariosEmpl.length > 0){
        const consultaUser = (permisoUsuariosEmpl[0].PerfilModuloConsulta === 1)?true:false;
        const addUser = (permisoUsuariosEmpl[0].PerfilModuloAgregar === 1)?true:false;
        
        setIsAgregarUsuEmp(addUser);
        //setIsConsultaUsuEmp(consultaUser);
        setIsModificarUsuEmp((permisoUsuariosEmpl[0].PerfilModuloModificar === 1)?true:false);   
        setIsEliminarUsuEmp((permisoUsuariosEmpl[0].PerfilModuloEliminar === 1)?true:false);   
        setIsBtnConsultarUserDisabled((consultaUser)?false:true);
        setIsBtnRegUserDisabled((addUser)?false:true);
      }

      if(permisoCargaMasiva != undefined && permisoCargaMasiva.length > 0){
        const addCargaMasiva = (permisoCargaMasiva[0].PerfilModuloAgregar === 1)?true:false;
        setIsBtnsCargaMasivaDisabled((addCargaMasiva)?false:true);
      }
    }
  }; //Fin AU

 
  useEffect(() => {
    //consultarUsuarios();
    AU.validaPermisos();
    AU.catPerfiles();
    
  }, []);

 
  function setPerfil(idPerfil) {
    if (idPerfil != 3) { 
      setTxtNumEmplDisabled(true);
      setTxtCorreoDisabled(false);
      setTxtPasswordlDisabled(false);
    } else { // 3: Empleado
      setNumEmpleado('');
      setCorreo('');
      setPassword('');
      setTxtNumEmplDisabled(false);
      setTxtCorreoDisabled(true);
      setTxtPasswordlDisabled(true);
    }
    setPerfilSeleccionado(idPerfil);
  }

  function limpiarFormulario() {
    setAltaOrActualizaUsuario(0);
    setPerfilSeleccionado('0');
    setRequiredPassword(true);
    setIsBtnRegUserDisabled((isAgregarUsuEmp)?false:true);
    setNombre('');
    setRfc('');
    setCurp('');
    setNumEmpleado('');
    setCorreo('');
    setPassword('');
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    if(isAltaOrActualizaUsuario == 0){
      if(isAgregarUsuEmp){
        AU.altaUsuario();
      } else {
        setMsgRegistro({ "showMsg": 1, "kind":"error", "Mensaje": "El usuario no tiene permiso para realizar esta acción."});
      }
    } else {
      AU.actualizarUsuario();
    }
    
  }

  return (
    <Content>
        <Grid>
        <Column lg={16} md={4} sm={4}>
          <h3 style={{ margin: '15px 0 20px' }}>Administración de usuarios y empleados.</h3>
          <AU.ColorHrLine color={'black'}></AU.ColorHrLine>
        </Column> 
        <Column lg={4} md={4} sm={4}> </Column>  
        <Column lg={6} md={4} sm={4}> </Column>
      </Grid>
      <br/><br/>
    <FlexGrid>
      <Loading className={'some-class'} active={loading} withOverlay={true} />
      <Row>
        <br />
        <Grid>
          <Column lg={16} md={16} sm={16}>
            <Accordion>
              <AccordionItem title="Carga masiva de empleados." 
                             open={false} 
                             disabled={false}
              >
                <form aria-label="carga form" style={{width: '1120px'}}>
                  <Stack gap={5}>
                    <Grid>
                    <Column lg={4} md={4} sm={4}>
                        <AU.spanHeight  height="2.8vh" />
                        <Button kind="tertiary" id="btnDesPlanCat" 
                                onClick={() => AU.getPlantilla()} 
                                disabled={isbtnsCargaMasivaDisabled}>
                            Descargar plantilla
                        </Button>
                    </Column> 
                      <Column lg={4} md={4} sm={4}> 
                          <div className="cds--file__container">
                            <FileUploader
                              labelTitle=""
                              labelDescription=""
                              buttonLabel="Selecciona un archivo"
                              buttonKind="secondary"
                              size="lg"
                              filenameStatus="edit"
                              accept={['application/vnd.ms-excel',
                                        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                                      ]}
                              multiple={false}
                              disabled={isbtnsCargaMasivaDisabled}
                              iconDescription="Delete file"
                              id="fileEmpleados"
                              onChange={() => AU.subirArchivo()}
                            />
                          </div>
                      </Column>  
                      <Column lg={4} md={4} sm={4}> 
                        <AU.spanHeight  height="2.5vh" />
                        <Button kind="secondary" 
                                id="btnCargaCat" 
                                disabled={(btnCargarEmpl || isbtnsCargaMasivaDisabled)}
                                onClick={() => AU.cargaMasivaEmpl()}
                                >
                            Cargar
                        </Button>
                      </Column>
                      </Grid>
                      <Grid>
                      <Column lg={12} md={12} sm={12}> 
                          <AU.spanHeight  height="2.5vh" />
                          {( msgCargaMasiva.showMsg == 1) && 
                            <InlineNotification 
                                  title={msgCargaMasiva.Mensaje}
                                  kind={msgCargaMasiva.kind} 
                                  lowContrast={true} 
                                  onClick={() => AU.hideMsgCargaMasiva()}
                            />
                        }
                      </Column>
                    </Grid>
                  </Stack>
                  <AU.spanHeight  height="8vh" />
                  <Grid>
                      <Column lg={16} md={16} sm={16}>
                      { showTableErrores ?  
                        <ErroresTable rows={rowsErrores}/>
                        :
                        ""
                      }
                      </Column>
                  </Grid>
                </form>
              </AccordionItem>
              <AccordionItem title="Administración de usuarios y empleados.." 
                             open={false}
              >
                <Form aria-label="User form" onSubmit={handleSubmit} style={{width: '1120px'}}>
                  {/*<TextInput id="idHidden" labelText="" hidden type="text" />*/}
                  <Grid>
                    <Column lg={4} md={4} sm={4}>
                      <Select id="cboPerfil" labelText="Perfil" required
                              onChange={(e) => setPerfil(e.target.value)} 
                              value={perfilSeleccionado} >
                        <SelectItem value="0" text="Selecciona una opción" />
                        {perfiles.map((item, key) => {
                          return <SelectItem key={key} id={'o' + key} value={item.id} text={item.text} />
                        })}
                      </Select>
                    </Column>
                    <Column lg={4} md={4} sm={4}>
                      <TextInput
                        id="txtNomCompleto"
                        placeholder="Nombre completo"
                        labelText="Nombre completo"
                        value={nombre}
                        required
                        onChange={(e) => setNombre(e.target.value)}
                        /*{...TextInputNombreProps}*/
                      />
                    </Column>
                    <Column lg={4} md={4} sm={4}>
                      <TextInput
                        id='txtRfc'
                        labelText='RFC'
                        placeholder='RFC'
                        value={rfc}
                        required
                        onChange={(e) => setRfc(e.target.value)}
                      />
                    </Column>
                    <Column lg={4} md={4} sm={4}>
                      <TextInput
                        id='txtCurp'
                        labelText='CURP'
                        placeholder='CURP'
                        value={curp}
                        required
                        onChange={(e) => setCurp(e.target.value)}
                      />
                    </Column>
                  </Grid>
                  <br />
                  <Grid>
                    <Column lg={4} md={4} sm={4}>
                      <TextInput
                        id="txtNumEmpleado"
                        placeholder="Número de empleado"
                        labelText="Número de empleado"
                        value={numEmpleado}
                        required
                        disabled={isTxtNumEmplDisabled}
                        onChange={(e) => setNumEmpleado(e.target.value)}
                      />
                    </Column>
                    <Column lg={4} md={4} sm={4}>
                      <TextInput
                        id='txtCorreo'
                        labelText='Correo'
                        placeholder='Correo'
                        value={correo}
                        required
                        disabled={isTxtCorreoDisabled}
                        onChange={(e) => setCorreo(e.target.value)}
                      />
                    </Column>
                    <Column lg={4} md={4} sm={4}>
                      <TextInput.PasswordInput id="txtPassw"
                        placeholder="Contraseña"
                        labelText="Contraseña"
                        value={password}
                        required={requiredPassword}
                        disabled={isTxtPasswordDisabled}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                    </Column>
                    <Column lg={4} md={4} sm={4}>
                      {/* 
                      <TextInput.PasswordInput id="txtConfirmPass"
                        placeholder="Confirma contraseña"
                        labelText="Confirmar contraseña"
                        value={confirmPass}
                        required
                        disabled={isTxtConfPasswordDisabled}
                        onChange={(e) => setConfirmPass(e.target.value)}
                      />
                      */}
                    </Column>
                  </Grid>
                  <br /><br />
                  <Grid>
                    <Column lg={4} md={4} sm={4}>
                        <br />
                        <ButtonSet style={{width:125}}>
                          <Button id="btnLimpiar" kind="ghost" 
                                  onClick={() => { limpiarFormulario() }}>
                            Limpiar
                          </Button>
                          &nbsp;
                          <Button id="btnBuscar" kind="secondary" disabled={isbtnConsultarUserDisabled}
                                  onClick={() => { AU.buscarUsuarios() }}>
                            Consultar
                          </Button>
                          &nbsp;
                          <Button type="submit" kind="primary" id="btnRegUser" disabled={isbtnRegUserDisabled}>
                            {(isAltaOrActualizaUsuario == 0 ? "Guardar" : "Actualizar")}
                          </Button>
                        </ButtonSet>
                    </Column>
                  </Grid>
                  <br /><br />
                  <Row>
                    <Grid>
                      <Column lg={16} md={16} sm={16} >
                        {msgRegistro.showMsg === 1 && 
                          <InlineNotification 
                                  title={msgRegistro.Mensaje}
                                  kind={msgRegistro.kind} 
                                  lowContrast={true} 
                                  onClick={AU.hideMsgRegistro}
                          />
                        }
                        <br /><br />
                      <AdmonUsuariosTable rows={usuarios} />
                      </Column>
                    </Grid>
                  </Row>
                </Form>
              </AccordionItem>
            </Accordion>
          </Column>
        </Grid>
      </Row>
    </FlexGrid>
    </Content>
  );
};

export default AdmonUsuarios;